<template>
  <div class="left-box active">
    <div class="left-title d-aligncnter d-between">
      <div class="d-aligncnter">
        <!-- <img src="@/assets/img/venuesorder/time.svg" style="margin-right: 8px" /> -->
        24小时锻炼活跃度（人数）
      </div>
      <div class="select-option" v-if="canChose" style="margin-right: 16px">
        <el-date-picker
          v-model="currDate"
          type="date"
          placeholder="选择日期"
          :clearable="false"
          @change="DayDateChange"
          :picker-options="maxOptions"
        >
        </el-date-picker>
      </div>
    </div>

    <div class="echarts" v-if="size == 'large'">
      <div
        id="activeone"
        :style="{
          width: '840px',
          height: '340px',
          margin: '0 auto',
        }"
      ></div>
    </div>
    <div class="echarts" v-else>
      <div
        id="active"
        :style="{
          width: '840px',
          height: '240px',
          margin: '0 auto',
        }"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['hoursData', 'size', 'dayDateActive', 'canChose'],
  data() {
    return {
      echartsData: '',
      option1: {},
      currDate: '',
      maxDate: new Date(),
      maxOptions: {
        disabledDate(time) {
          if (time.getTime() > Date.now()) {
            return true
          } else {
            return false
          }
        },
      },
    }
  },
  watch: {
    hoursData: {
      handler: function (newVal) {
        this.echartsData = newVal
        this.currDate = this.dayDateActive
        // var myChart1 = this.$echarts.init(document.getElementById('active'))
        // myChart1.setOption(this.option1)
      },
      deep: true,
    },
  },
  created() {
    this.currDate = this.dayDateActive
    this.echartsData = this.hoursData
  },
  mounted() {
    // setTimeout(() => {
    //   var myChart1 = this.$echarts.init(document.getElementById('active'))
    //   myChart1.setOption(this.option1)
    // }, 6000)
    // this.drawMonthData(this.hoursData)
    // window.onresize = () => {
    //   return (() => {
    //     this.drawMonthData(this.hoursData)
    //   })()
    // }
  },
  computed: {},
  methods: {
    DayDateChange() {
      console.log('???')
      console.log(this.formatDate(this.currDate))
      this.$emit('changeDayDateActive', this.formatDate(this.currDate))
      // this.$emit('dayDateChange', this.currDate)
    },
    formatDate(date) {
      var dateObj = new Date(date)
      var year = dateObj.getFullYear().toString()
      var month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
      var day = dateObj.getDate().toString().padStart(2, '0')
      var formattedDate = `${year}-${month}-${day}`
      return formattedDate
    },
    drawMonthData(data, xdata) {
      console.log('active?', data, xdata)
      console.log('active?', data, xdata)
      var myChart1 = {}
      if (this.size == 'large') {
        myChart1 = this.$echarts.init(document.getElementById('activeone'))
      } else {
        myChart1 = this.$echarts.init(document.getElementById('active'))
      }
      this.option1 = {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: '5%', // 上边距可以是百分比或像素值
          right: '5%', // 右边距
          bottom: '22%', // 下边距
          left: '4%', // 左边距
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          //   axisLabel: { interval: 0, rotate: 30 },
          data: xdata,

          //   axisTick: {
          //     alignWithLabel: true,
          //   },
        },
        axisLabel: {
          color: '#339571',
        },
        yAxis: {
          //   type: 'value',
          //   minInterval: 10,
          maxInterval: 10,
          axisLine: {
            show: true, //是否显示轴线
            lineStyle: {
              color: '#339571', //刻度线的颜色
            },
          },
          splitLine: {
            // show: false,
            lineStyle: {
              color: '#339571',
            },
          },
        },
        series: [
          {
            name: '时间',
            type: 'line',
            symbol: 'none',
            sampling: 'lttb',
            areaStyle: {},
            data: data,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFB612' },
                { offset: 1, color: '#4DA282' },
              ]),
            },
          },
        ],
      }
      myChart1.setOption(this.option1)
    },
  },
}
</script>
<style scoped lang="scss">
.left-box {
  width: calc(100% - 0px);

  margin-top: 16px;

  .left-title {
    font-size: 22px;
    margin-bottom: 8px;
    margin-left: 24px;
  }
}
.echarts {
  width: calc(100% - 48px);
  //   background: linear-gradient(
  //     180deg,
  //     rgba(26, 135, 95, 0.15) 0%,
  //     rgba(0, 122, 77, 0.24) 100%
  //   );
  //   margin-left: calc(24px - 10%);
  height: 260px;
  //margin-top: -36px;
  //margin-left: -120px;
}
.select-option ::v-deep .el-input__inner,
.el-select-dropdown__item.is-disabled:hover {
  background-color: rgba(255, 255, 255, 0) !important;
}
.select-option ::v-deep .el-input__inner {
  //   border: 1px solid #007a4d !important;
  height: 36px;
  color: #fff;
  width: 104px;
  border: none;
  padding-right: 0px !important;
}
.select-option ::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 104px;
}
.select-option ::v-deep .el-input__icon {
  line-height: 36px;
}
</style>
